import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Program from "./pages/Program";
import HealthSafety from "./pages/HealthSafety";
import Cameras from "./pages/Cameras";
import ParentPartnership from "./pages/ParentPartnership";
import Enroll from "./pages/Enroll";
import Contact from "./pages/Contact";
import Photos from "./pages/Photos";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/program" element={<Program />} />
            <Route path="/health-safety" element={<HealthSafety />} />
            <Route path="/cameras" element={<Cameras />} />
            <Route path="/parent-partnership" element={<ParentPartnership />} />
            <Route path="/enroll" element={<Enroll />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/photos" element={<Photos />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCallButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;